import { InveniasDataSourceApiService, InveniasEntityTypes, InveniasListTypes } from 'datasource-service-lib';
import { Namespace } from 'enums-lib';
import { IEntity, INamedEntity } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { runtimeEnvironment } from '../../../../environments/environment';
import {
  ISimpleTableColumn,
  ISimpleTableRow,
  SimpleTableSortFunctions,
} from '../../../common-components/simple-table/simple-table.interfaces';
import { DocumentClientDatasourceApiListServiceFactory } from '../../../services/datasource/document-client-datasource-list.service';
import { IEntitySelectDialogService } from './ientityselectdialogservice';

export class InveniasEntitySelectDialogService implements IEntitySelectDialogService {
  private static readonly FIELDS = ['ItemId', 'DisplayFileAs', 'Relation_recordstatus'];

  constructor(private dataSourceApiService: InveniasDataSourceApiService) {
    console.debug('InveniasEntitySelectDialogService created.');
  }

  getDisplayTerms(entity: IEntity): {
    listEntityType: string;
    listEntityLabel: string;
  } {
    const { listType, listEntityType } = this.listType(entity.type);
    return { listEntityType: listEntityType, listEntityLabel: listType };
  }

  getDisplayColumns(): ISimpleTableColumn[] {
    if (runtimeEnvironment.renderMode === 'web-app') {
      return [
        {
          title: 'Name',
          width: '50%',
          sortFunction: SimpleTableSortFunctions.sortByTextField('name'),
        },
        {
          title: 'Progress Status',
          width: '50%',
          sortFunction: SimpleTableSortFunctions.sortByTextField('status'),
        },
      ];
    }

    // chrome-extension
    return [
      {
        title: 'Name',
        width: '50%',
        sortFunction: SimpleTableSortFunctions.sortByTextField('name'),
      },
      {
        title: 'Progress Status',
        width: '50%',
        sortFunction: SimpleTableSortFunctions.sortByTextField('status'),
      },
    ];
  }

  getRows(entity: IEntity): Observable<ISimpleTableRow[]> {
    const { listType, listEntityType } = this.listType(entity.type);
    console.debug(`Invenias: getEntities(${entity.type}), listType=${listType}, listEntityType=${listEntityType}`);

    const listParams = {
      entity: entity,
      associatedType: listType,
      fields: InveniasEntitySelectDialogService.FIELDS,
    };
    return DocumentClientDatasourceApiListServiceFactory.instance
      .create(Namespace.invenias, this.dataSourceApiService)
      .list(listParams)
      .pipe(
        map((resp) => {
          return resp.map((item) => {
            const entityInfo = {
              id: item.ItemId,
              type: listEntityType,
              name: item.DisplayFileAs,
              status: item.Relation_recordstatus.ItemDisplayText,
            };
            return this.buildTableRow(entityInfo);
          });
        })
      );
  }

  private listType(entityType: string): {
    listType: string;
    listEntityType: string;
  } {
    if (entityType === InveniasEntityTypes.Assignments) {
      return {
        listType: InveniasListTypes.Candidates,
        listEntityType: InveniasEntityTypes.People,
      };
    }

    throw new Error(`Unexpected entity type '${entityType}'.`);
  }

  private buildTableRow(entityInfo: INamedEntity & { status: string }): ISimpleTableRow {
    const cells = [{ text: entityInfo.name }, { text: entityInfo.status }];
    return { cells: cells, data: entityInfo };
  }
}
